<template>
  <div class="list-indicators">
    <h1>List of Indicators</h1>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll(1)">Indicator 1. HIV Testing Episodes</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll(2)">Indicator 2. HIV Testing Rate</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll(3)">Indicator 3. New HIV Diagnoses</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll(4)">Indicator 4. Stage of HIV Infection at Diagnosis</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll(5)">Indicator 5. HIV Cascade of Care</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll(6)">Indicator 6. Programmatic Compliance Score (PCS)</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll('7a')">Indicator 7. New Antiretroviral Therapy Starts</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll('8a')">Indicator 8. CD4 Cell Count at ART Initiation</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll('9a')">Indicator 9. Active and Inactive Drug Treatment Program (DTP) Participants</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll('10a')">Indicator 10. Antiretroviral Adherence</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll('11a')">Indicator 11. Resistance Testing and Results</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll('12a')">Indicator 12. AIDS-Defining Illness</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll('13a')">Indicator 13. HIV-Related Mortality</a>
    <a class="list-indicator" href="javascript:void(0);" @click="goToByScroll('appendices')">Appendices</a>
  </div>
</template>

<script>
import * as $ from 'jquery';
export default {
  mounted() {
    // if (this.$route.params.ha !== 'bc') {
    //   $('#app > div > div.list-indicators.bottom-padded-2x > a:nth-child(15)').css({
    //     'background-color': 'rgba(255, 255, 0, 0.5)'
    //   });
    // }
  },
  methods: {
    goToByScroll(id){
      $('html,body').animate({scrollTop: $("#"+id).offset().top}, 'fast');
    }
  },
  data () {
    return {
      msg: 'Home'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a {
    display: table;
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// ListIndicators.vue?b7fdd310